export default __webpack_public_path__ + "static/media/sort-down.8c5d609c.svg";